"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialsProvider = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
function CredentialsProvider({ children, }) {
    const saleor = __1.useSaleorClient();
    const [signIn] = __1.useSignIn();
    const autoSignIn = () => __awaiter(this, void 0, void 0, function* () {
        const credentials = yield navigator.credentials.get({
            password: true,
        });
        if (credentials) {
            yield signIn({
                email: credentials.id,
                password: credentials.password,
            });
        }
    });
    react_1.default.useEffect(() => {
        if (!saleor.legacyAPIProxy.isLoggedIn() && window.PasswordCredential) {
            autoSignIn();
        }
    }, []);
    return children;
}
exports.CredentialsProvider = CredentialsProvider;
//# sourceMappingURL=CredentialsProvider.js.map